import { EventosDto } from '../../dto'

export const DEFAULT_EVENTS_STORAGE: EventosDto = {
	Carrito: null
};